// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const burgerMenuBtn = document.querySelector('[data-burgeropen]');
const burgerMenuClose = document.querySelector('[data-burgerclose]');
const burgerMenu = document.querySelector('[data-burgermenu]');

(function(){

	//burger menu
	if(burgerMenu) {
		burgerMenuBtn.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.add('open');
			document.body.classList.add('no-scroll');
		});

		burgerMenuClose.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});

		burgerMenu.querySelectorAll('a[href]').forEach(link => {
			link.addEventListener('click', () => {
				const href = link.getAttribute('href');
				const isAnchor = href.startsWith('#');
				const isSamePage = href.includes(window.location.pathname) && href.includes('#');
		
				if (isAnchor || isSamePage) {
					burgerMenu.classList.remove('open');
					document.body.classList.remove('no-scroll');
				}
			});
		});
	}

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};


    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	/*****************************************************
	OBSERVER TO ADD PARALLAX EFFECT
	*****************************************************/
	let scrollParallax = []
	let scrolled = 0
	/* screen height */
	let v_height = window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight;

	function doParallax(elm) {
		let boundes = elm.dataset.parallax.split(",") /* get it from html */
		/*get distance in positive value*/
		let distance = Math.abs(boundes[0] - boundes[1])
		if (boundes[0] > boundes[1]) {
			/*get distance in negative value (to do the scroll inverse)*/
			distance = distance * -1
		}
		/*Equivalent distance using screen height + element height*/
		const unit_scroll = distance / (v_height + elm.offsetHeight)
		let temp = 0
		let topElement = 0;
		let element = elm;
		let id_elem = elm.dataset.parallaxid
		do {
			topElement += element.offsetTop || 0;
			element = element.offsetParent;
		} while (element)
		let parallaxFunction = function () {
			/*Obtain the distance between top screen and document top 0*/
			scrolled = document.documentElement.scrollTop || window.pageYOffset
			/*Distance of bottom page to top of the element*/
			let relative_distance = scrolled + v_height - topElement
			/*transpoling data to move the parallax element relative to the scroll of all the screen*/
			temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
			/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
			elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
		}
		scrollParallax[id_elem] = parallaxFunction
		window.addEventListener('scroll', scrollParallax[id_elem])
	}

	let observers_parallax = document.querySelectorAll(".js-parallax-element");

	if (observers_parallax) {
		let options_parallax = {
			root: null, /* relative to document viewport */
			rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
			threshold: 0 /* visible amount of item shown in relation to root */
		}

		function handler_parallax(entries, observer) {
			let entry;
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					doParallax(entry.target)
				} else {
					let id_elem = entry.target.dataset.parallaxid
					window.removeEventListener('scroll', scrollParallax[id_elem])
				}
			})
		}

		let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax);
		let counter = 1;
		observers_parallax.forEach(function (element) {
			observable_parallax.observe(element)
			element.dataset.parallaxid = counter
			counter++
		})
	}
	/********************************************************************************
	END OF OBSERVER TO ADD PARALLAX EFFECT
	******************************************************************************/

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

const focusableSelector = `
  a[href],
  button,
  input,
  textarea,
  select,
  [tabindex]:not([tabindex="-1"])
`;

function disableFocusOutside(container, key) {
	const focusables = document.querySelectorAll(focusableSelector);
  
	focusables.forEach(el => {
	  if (container.contains(el)) return;
  
	  const attr = `data-prev-tabindex-${key}`;
  
	  if (!el.hasAttribute(attr)) {
		const prev = el.getAttribute('tabindex');
		el.setAttribute(attr, prev === null ? 'none' : prev);
	  }
  
	  el.setAttribute('tabindex', '-1');
	});
}
  
  
function restoreFocus(key) {
	const stored = document.querySelectorAll(`[data-prev-tabindex-${key}]`);
  
	stored.forEach(el => {
	  const prev = el.getAttribute(`data-prev-tabindex-${key}`);
  
	  if (prev === 'none') {
		el.removeAttribute('tabindex');
	  } else {
		el.setAttribute('tabindex', prev);
	  }
  
	  el.removeAttribute(`data-prev-tabindex-${key}`);
	});
}

if(screen.width > 600) {
	document.addEventListener('DOMContentLoaded', () => {

		const burgerObserver = new MutationObserver(() => {
			if (document.body.classList.contains("burger-open")) {
			disableFocusOutside(burgerMenu, 'burger');
			} else {
			restoreFocus('burger');
			}
		});
		
		burgerObserver.observe(document.body, {
			attributes: true,
			attributeFilter: ["class"]
		});

		const lightboxObserver = new MutationObserver(() => {
			if (document.body.classList.contains("lbx_body-noscroll")) {
			disableFocusOutside(document.querySelector('.lbx'), 'lightbox');
			} else {
			restoreFocus('lightbox');
			}
		});
		
		lightboxObserver.observe(document.body, {
			attributes: true,
			attributeFilter: ["class"]
		});  
	});
}